import types from '../actionTypes';

export const redirect = (url = null) => ({ type: types.SET_REDIRECT, url });

//toggle screen size over 1024px or below
export const toggleDisplaySize = (size, status) => ({ type: types.SET_DISPLAY_SIZE, size, status });

//mobile filter and editor modules toggle
export const openFilter = () => ({ type: types.OPEN_FILTER });
export const openEditor = () => ({ type: types.OPEN_EDITOR_MODULES });
export const closeModules = () => {
	return (dispatch) => {
		dispatch({ type: types.CLOSE_FILTER });
		dispatch({ type: types.CLOSE_EDITOR_MODULES });
	};
};

export const apiError = (state) => ({ type: types.SET_API_ERROR, state });

export const fadeInModule = (moduleName) => ({ type: types.FADE_IN_MODULE, moduleName });
